class PopoutCartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.buildRecommendations(null);
    this.addListeners();
    this.caret = `
      <svg aria-hidden="true" focusable="false" class="icon icon-caret popout-cart__recommendations-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
      </svg>
    `;
  }
  
  addListeners() {
    document.addEventListener('cart:requestStart', (e) => {
      if (e.detail && e.detail.qtyChange) return;
      
      this.classList.add('popout-cart-recommendations-loading');
    });
    
    document.addEventListener('cart:requestComplete', (e) => {
      if (e.detail && e.detail.qtyChange) return;

      const cart = e.detail.data;

      this.buildRecommendations.apply(this, [cart]);
    });
  }

  buildRecommendations(cart) {
    const requests = [];
    const requestedIds = [];
    let productIds;

    if (cart) {
      productIds = [];
      cart.items.forEach((item) => {
        productIds.push(item.product_id);
      })
    } else {
      const thisIds = this.getAttribute('data-product-ids');
      if (thisIds == '') return;
      productIds = thisIds.split('|');
    }

    if (productIds.length > 0) {
      productIds.forEach((id) => {
        if (!requestedIds.includes(id)) {
          requests.push(fetch(`/recommendations/products?product_id=${id}&section_id=stmt-popout-cart-recommendations`))
          requestedIds.push(id);
        }
      });
    };

    if (!requestedIds.length) {
      this.classList.add('popout-cart__recommendations-no-results');
      this.classList.remove('popout-cart-recommendations-loading');
      return;
    }

    if (productIds.length > 0) {
      Promise.all(
        requests
      ).then((responses) => {
        return Promise.all(responses.map((response) => {
          return response.text();
        }));
      }).then((products) => {
        const recommendationParentProductIds = [];
        const recommendationProductIds = [];
        const recommendationsToShow = [];
        const recommendationsList = document.querySelector('.js-popout-cart-recommendations-list');
  
        if (!recommendationsList) return;
  
        products.forEach((product) => {
          const parser = new DOMParser();
          const productHtml = parser.parseFromString(product, "text/html");
          const recommendations = productHtml.querySelector('.js-recommendations');
  
          if (!recommendations) return;
  
          const recommendationsItems = recommendations.querySelectorAll('.js-popout-cart-recommendation');
  
          recommendationsItems.forEach((recommendation) => {
            const recommendationParentProductId = recommendation.getAttribute('data-recommendation-parent-product-id');
            const recommendationProductId = recommendation.getAttribute('data-recommendation-product-id');
  
            if (!recommendationProductIds.includes(recommendationProductId)) {
              recommendationsToShow.push({
                recommendation,
                recommendationParentProductId
              });
            }
  
            if (!recommendationParentProductIds.includes(recommendationParentProductId)) {
              recommendationParentProductIds.push(recommendationParentProductId);
            }
  
            recommendationProductIds.push(recommendationProductId);
          })
        });
        
        const groupedRecommendations = [];
  
        recommendationParentProductIds.forEach((parentProductId) => {
          const group = [];
  
          recommendationsToShow.forEach((el) => {
            if (el.recommendationParentProductId === parentProductId) {
              group.push(el.recommendation);
            }
          });
  
          groupedRecommendations.push(group);
        });
  
        recommendationsList.innerHTML = '';
  
        const interleave = (array) => Array.from({ length: Math.max(...array.map(a => a.length)) }, (_, i) => array.map(b => b[i] ?? null)).flat().filter(c => c);
        const interleavedRecommendations = interleave(groupedRecommendations);
  
        if (interleavedRecommendations.length) {
          this.classList.remove('popout-cart__recommendations-no-results');
  
          let items = '';
          let controls = '';
          let progressBar = '';
  
          if (interleavedRecommendations.length > 1) {
            controls = `
              <div class="popout-cart__recommendations-slider-controls slider-buttons">
                <button
                  type="button"
                  class="popout-cart__recommendations-slider-button popout-cart__recommendations-slider-button--prev slider-button slider-button--prev"
                  name="previous"
                  data-step="1"
                >
                  ${this.caret}
                </button>
                <button
                  type="button"
                  class="popout-cart__recommendations-slider-button popout-cart__recommendations-slider-button--next slider-button slider-button--next"
                  name="next"
                  data-step="1"
                >
                  ${this.caret}
                </button>
              </div>
            `;
  
            progressBar = `
              <div class="popout-cart__recommendations-slider-progress-bar-wrap">
                <div class="popout-cart__recommendations-slider-progress-bar slider-progress-bar">
                  <span class="popout-cart__recommendations-slider-progress-bar-value slider-progress-bar__value"></span>
                </div>
              </div>
            `;
          }
  
          interleavedRecommendations.forEach((recommendation, index) => {
            if (index > 12) return;
  
            items += `
              <li
                id="Slide-PopoutCartRecommendations-${index}"
                class="popout-cart__recommendations-slider-item slider__slide"
              >
                ${recommendation.innerHTML}
              </li>
            `;
          });
  
          recommendationsList.innerHTML = `
            <slider-component class="popout-cart__recommendations-slider slider">
              ${controls}
              <ul
                class="slider popout-cart__recommendations-slider-items"
                id="Slider-PopoutCartRecommendations"
                role="list"
              >
                ${items}
              </ul>
              ${progressBar}
            </slider-component>
          `;
        } else {
          this.classList.add('popout-cart__recommendations-no-results');
        }
  
        this.classList.remove('popout-cart-recommendations-loading');
      }).catch((error) => {
        this.classList.add('popout-cart__recommendations-no-results');
        console.error(error);
      });
    } else {
      this.classList.add('popout-cart__recommendations-no-results');
    }
    
  }
}

class PopoutCartRecommendation extends HTMLElement {
  
  constructor(){
    super();
    this.form = this.querySelector('.js-popout-cart-recommendation-form');
    this.options = '';
    this.variantData = '';
    this.currentVariant = '';
    this.listeners();
  }

  listeners() {
    if (this.form) {      
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addToCart();
      });

      this.form.addEventListener('change', () => {
        this.updateSelectedVariant();
      });
    }
  }

  addToCart() {
    const formData = new FormData(this.form);
    const max = this.getAttribute('data-max');
    const sections = ['stmt-popout-cart-delivery-banner', 'stmt-popout-cart-items', 'stmt-popout-cart-footer'];
    let ageValidation = false;

    if(this.form.querySelector('.js-age-restricted-check')){
      ageValidation = this.form.querySelector('.js-age-restricted-check').value;
    } else {
      ageValidation = false;
    }

    if(ageValidation == "true" && window.getCookie('ageOver16') != 'true'){
      document.dispatchEvent(new CustomEvent('age-validation:show'));
    } else {
      document.dispatchEvent(
        new CustomEvent('cart:add', { 
          detail: {
            data: { formData: formData, max: max, sections: sections }
          }
        })
      )
    }
  }

  updateSelectedVariant(variant) {    
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

    if (variant) {
      this.currentVariant = variant;
    } else {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    if (!this.currentVariant) {
      this.variantNotFound();
    } else {
      this.updateUrl();
      this.updateImage();
      this.updateAddToCart();
      this.updateVariantInput();
      this.updateAvailability();
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('.js-popout-card-recommendation-variants').textContent);
    return this.variantData;
  }

  updateAddToCart() {
    const addToCartPriceLabel = this.querySelector('.js-popout-cart-recommendation-submit-price-label');

    if (!addToCartPriceLabel) return;
    
    addToCartPriceLabel.innerText = this.currentVariant.price;
  }

  updateUrl() {
    const links = this.querySelectorAll('.js-popout-cart-recommendation-link');
    const selectedVariantUrl = this.currentVariant.url;

    if (!selectedVariantUrl) return;

    links.forEach((el) => {
      el.href = selectedVariantUrl;
    }); 
  }

  updateImage() {
    const image = this.querySelector('.js-popout-cart-recommendation-image');

    if (!image) return;

    const currentImage = image.querySelector('img').src;

    if (currentImage.includes(this.currentVariant.image.src)) return;

    image.innerHTML = this.currentVariant.image.html;
  }

  updateVariantInput() {
    const input = this.form.querySelector('input[name="id"]');

    if (!input) return;

    input.value = this.currentVariant.id;
  }

  updateAvailability() {
    const available = this.currentVariant.available;
    const submit = this.querySelector('.js-popout-cart-recommendation-submit');

    if (!submit) return;

    if (available) {
      submit.removeAttribute('disabled');
    } else {
      submit.setAttribute('disabled', 'disabled');
    }
  }

  variantNotFound() {
    const submit = this.querySelector('.js-popout-cart-recommendation-submit');
    
    if (!submit) return;

    submit.setAttribute('disabled', 'disabled');
  }
}

customElements.define('popout-cart-recommendations', PopoutCartRecommendations);
customElements.define('popout-cart-recommendation', PopoutCartRecommendation);
